/**
 * Overlay
 */
(function ($) {
  $(document).on("ready", function () {
    $(document).on("click", "#overlay, #olClose, .olClose", function (e) {
      // Don't close modals on text selections
      const selection = document.getSelection();
      if (selection.type === "Range") {
        e.stopPropagation();
        return;
      }

      if (e.target == this) {
        $("#overlay").remove();
      }
    });
  });
})(window.jQuery);
